import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const PatchUserLifecycleFlag = async ({
    userId,
    flag
}: {
    userId: string;
    flag: string;
}): Promise<boolean | null> => {
    try {
        const response = await Requester<Record<string, boolean>>({
            path: `users/${userId}/flags/${flag}`,
            method: 'PATCH'
        });

        return Object.hasOwn(response, flag) ? response[flag as keyof typeof response] : null;
    } catch (e) {
        console.error('Patch user lifecycle flag request failed');
        return Promise.reject(e);
    }
};
